module.exports = __webpack_public_path__ + "static/radio-9631aca9709d49983eb8fd593e5b399f.jpg";